import * as React from "react"
import styled from "styled-components"
import { getFormattedPrice } from "../../../utils/cart-helpers"
import { DeliveryMethod } from "../../interfaces/SaleorTypes"
import { HorizontalSpacer } from "../../atoms/spacers"
import BodyMedium from "../../atoms/typography/BodyMedium"
import H4 from "../../atoms/typography/H4"

interface ConfirmationAccessorySectionProps {
  shippingMethod: DeliveryMethod
}

const SubHeaderWrapper = styled.div`
  margin-bottom: 0.4em;
`

const Divider = styled.div`
  border: solid 1px #898989;
`

const ConfirmationItemCardContainer = styled.div`
  margin: 1em 0;
`

const ConfirmationItemCardRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1em 0;
`

const ConfirmationItemCardData = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
`

const ProductContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const InfoTitleContainer = styled.div``

const PriceContainer = styled.div`
  display: flex;
  justify-content: center;
`

const ConfirmationShippingSection: React.FunctionComponent<ConfirmationAccessorySectionProps> = ({
  shippingMethod,
  ...props
}) => {
  return (
    <div>
      {shippingMethod && (
        <div>
          <HorizontalSpacer spacing={2} />
          <SubHeaderWrapper>
            <BodyMedium>Shipping</BodyMedium>
          </SubHeaderWrapper>
          <Divider />
          <ConfirmationItemCardContainer>
            <ConfirmationItemCardRow>
              <ProductContainer>
                <InfoContainer>
                  <InfoTitleContainer>
                    <H4>{shippingMethod.name}</H4>
                  </InfoTitleContainer>
                </InfoContainer>
              </ProductContainer>
            </ConfirmationItemCardRow>
            <ConfirmationItemCardRow>
              <BodyMedium>Price:</BodyMedium>
              <ConfirmationItemCardData>
                <PriceContainer>
                  <BodyMedium>
                    {getFormattedPrice(shippingMethod.price.amount, shippingMethod.price.currency)}
                  </BodyMedium>
                </PriceContainer>
              </ConfirmationItemCardData>
            </ConfirmationItemCardRow>
          </ConfirmationItemCardContainer>
        </div>
      )}
    </div>
  )
}

export default ConfirmationShippingSection
